import React, {FC} from "react";
import {getDaysInMonth, setDate} from "date-fns";
import {Card, CardContent} from "@material-ui/core";
import {SelectionMode, WorkersCalendarHeader} from "./WorkersCalendarHeader";
import {useAppDispatch, useAppSelector} from "../../redux/redux.hook";
import {selectAllWorkers} from "../workers/redux/workers.slice";
import {listWorkersThunk} from "../workers/redux/workers.thunk";
import {WorkersCalendarLane} from "./WorkersCalendarLane";
import {createSelector} from "@reduxjs/toolkit";
import {RootState} from "../../redux/store";
import {CreateAvailabilityDialogForm} from "../availibilities/form/CreateAvailabilityDialogForm";
import {useHistory, useLocation, useRouteMatch} from "react-router-dom";
import {WorkerCalendarLegend} from "./WorkerCalendarDayIndicator";
import {getFullName} from "../../utils";

const getFilteredWorkers = createSelector(
    (_state: RootState, searchString: string) => searchString as string,
    selectAllWorkers, (searchString, workers) => {
        return (
            workers.filter((w) => w.firstName.includes(searchString) || w.lastName.includes(searchString))
        )
    });

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

export const WorkersCalendar: FC = () => {
    const dispatch = useAppDispatch();

    const query = useQuery();

    const queryDate = query.get('firstOfSelectedMonth');

    const history = useHistory();
    const {url} = useRouteMatch();

    const [selectionMode, setSelectionMode] = React.useState<SelectionMode>('busy');
    const [searchString, setSearchString] = React.useState('');
    const firstOfSelectedMonth = queryDate ? new Date(Number(queryDate)): setDate(new Date(), 1);
    const amountOfDaysInSelectedMonth = getDaysInMonth(firstOfSelectedMonth);
    const workers = useAppSelector((state) => getFilteredWorkers(state, searchString));

    React.useEffect(() => {
        dispatch(listWorkersThunk())
    }, [dispatch]);

    return (
        <React.Fragment>
            <CreateAvailabilityDialogForm/>
            <Card variant="outlined">
                <CardContent>
                    <WorkersCalendarHeader
                        amountOfDays={amountOfDaysInSelectedMonth}
                        search={{searchString, onChange: setSearchString}}
                        selection={{setSelectionMode, selectionMode}}
                        pagination={{
                            firstOfSelectedMonth: firstOfSelectedMonth,
                            onChange: (newFirstOfSelectedMonth) => {
                                history.push(`${url}?firstOfSelectedMonth=${newFirstOfSelectedMonth.getTime()}`)
                            }
                        }}
                    />
                    {workers.filter((w) => w.active).map((w) => (
                        <WorkersCalendarLane
                            key={"worker-" + w.id}
                            worker={{id: w.id, name: getFullName(w, false)}}
                            selectedMonth={firstOfSelectedMonth}
                            amountOfDays={amountOfDaysInSelectedMonth}
                            selectionMode={selectionMode}
                        />
                    ))}
                    <WorkerCalendarLegend/>
                </CardContent>
            </Card>
        </React.Fragment>
    )
}
